'use strict';
var KeyMirror = require('keymirror');

module.exports = {

    ActionTypes: KeyMirror({
        UPDATE_BENEFICIARY_MODEL: null,
        SAVE_BENEFICIARY_ADDRESS: null
    }),
    BENEFICARY: 'bfyD',
    Type: {
        REVERSIONARY: 'Reversionary',
        NON_LAPSING: 'NonLapsing'
    },
    Relationship: {
        SPOUSE: 'Spouse',
        CHILD: 'Child',
        FINANCIAL_DEPENDANT: 'FinancialDependant',
        INTERDEPENDANT: 'Interdependant'
    },
    BeneficiaryTypeData: [
        { id: 'Reversionary', name: 'Reversionary', isHidden: false, isDisabled: false },
        { id: 'NonLapsing', name: 'Non-lapsing', isHidden: false, isDisabled: false }
    ],
    RelationshipData: [
        { id: 'Spouse', name: 'Spouse', isHidden: false, isDisabled: false },
        { id: 'Child', name: 'Child', isHidden: false, isDisabled: false },
        { id: 'FinancialDependant', name: 'Financial dependant', isHidden: false, isDisabled: false },
        { id: 'Interdependant', name: 'Interdependant', isHidden: false, isDisabled: false }
    ],
    AddressLabel: {
        residence: 'Postal address',
        address1: 'Address line 1',
        address2: 'Address line 2',
        CityStatePostCode: 'City/State/Postcode',
        CitySuburb: 'City/Suburb',
        state: 'State',
        postcode: 'Postcode',
        country: 'Country'
    },
    FieldNames: {
        IS_NOMINATED: 'isNominateBeneficiary',
        BENEFICIARY_TYPE: 'type',
        GENDER: 'gender',
        TITLE: 'title',
        GIVEN_NAME: 'givenName',
        LAST_NAME: 'lastName',
        RELATIONSHIP: 'relationship',
        DATE_OF_BIRTH: 'dateOfBirth',
        DEFINE_ADD_LINE: 'definePostalAddressLine',
        POSTAL: 'postal',
        POSTAL_COUNTRY: 'postalCountry',
        ADDRESS1: 'postalAddress1',
        ADDRESS2: 'postalAddress2',
        CITY_STATE_POST: 'postalCityStatePostCode',
        AUS_STATE: 'postalAusState',
        POST_CODE: 'postalPostCode',
        MOBILE_NUMBER: 'mobileNumber',
        HOME_NUMBER: 'homeNumber',
        WORK_NUMBER: 'workNumber',
        EMAIL_ADD: 'emailAddress'
    },
    Labels: {
        BENEFICIARY_SECTION: 'Beneficiary details',
        BENEFICIARY_TYPE: 'Beneficiary type',
        RELATIONSHIP: 'Relationship to you'
    },
    noNominationText: 'No nomination made',
    BeneficiaryData: {
        isNominateBeneficiary: 'N',
        type: '',
        gender: '',
        title: '',
        givenName: '',
        lastName: '',
        relationship: '',
        dateOfBirth: '',
        definePostalAddressLine: '',
        postal: '',
        postalCountry: 'AU',
        postalAddress1: '',
        postalAddress2: '',
        postalCityStatePostCode: '',
        postalAusState: '',
        postalPostCode: '',
        mobileNumber: '',
        homeNumber: '',
        workNumber: '',
        emailAddress: '',
        contactDetails: {},
        address: {}
    }
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./constants/BeneficiaryDetailsConstant.js